import { EMPTY_LIST } from '../../../../../constants/common'
import { EntityDeadlineStatus } from '../../../../Entity'
import { UserAvatarGroup } from '../../../../User'

import { hasRequestBoardCardMeta } from './RequestBoardCardMeta.utils'

import * as styles from './RequestBoardCardMeta.module.css'

function RequestBoardCardMeta({ assignees = EMPTY_LIST, dueDate, status }) {
  return hasRequestBoardCardMeta({ assignees, dueDate }) ? (
    <div className={styles.RequestBoardCardMeta}>
      <UserAvatarGroup users={assignees} />
      {dueDate ? (
        <EntityDeadlineStatus
          className={styles.deadline}
          deadline={dueDate}
          status={status}
        />
      ) : null}
    </div>
  ) : null
}

export default RequestBoardCardMeta
